import React from 'react';

const OrganizationStructuredData: React.FC = () => {
  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Deals n Steals',
    alternateName: 'DealsnSteals',
    url: window.location.origin,
    logo: `${window.location.origin}/images/logos/android-chrome-192x192.png`,
    description:
      'Find the best deals and steals online. Community-driven platform for discovering discounts, comparing prices, and saving money on your favorite products.',
    sameAs: [
      // Add your social media URLs here when available
      // "https://twitter.com/dealsnsteals",
      // "https://facebook.com/dealsnsteals",
      // "https://instagram.com/dealsnsteals"
    ],
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${window.location.origin}/search?q={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
  };

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Deals n Steals',
    url: window.location.origin,
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${window.location.origin}/search?q={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
    </>
  );
};

export default OrganizationStructuredData;
